import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import UseOfProceedsPageUI from './UseOfProceedsPageUI.js'

class UseOfProceedsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      createMode: false,
      billList: null
    }
  }

  render() {
    return (
      <UseOfProceedsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        billList={this.state.billList}
        onRefreshClick={this.onRefreshClick}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        createMode={this.state.createMode}
        onCancelClick={() => { this.setState({ createMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getBillList(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getBillList = (context) => {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/bills`,
      cacheKey: CacheKeys.BillsByLoanId(this.props.match.params.loanId),
      callback: this.getBillListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBillListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      billList: response.billList,
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.BillsByLoanId(this.props.match.params.loanId))
    if (noBusy === 'noBusy')
      this.getBillList(context)
    else
      this.setState({ loan: null, errorList: null, billList: null },
        this.getLoan(context),
        this.getBillList(context)
      )
  }
}

export default withRouter(UseOfProceedsPageSF)
